const ViewingRoom = `
  id
  description
  inactive
  siteId
`;

export default ViewingRoom;
